import React, { useCallback, useContext } from 'react';
import { Button } from '@chakra-ui/react';
import { InfluencerDataContext } from '../../../contexts/InfluencerDataContext';
import { useWhopPayoutsModal } from '../contexts/WhopPayoutsModalContext';
import { walletColors } from '../walletTheme';
import { WalletWithdrawArrowIcon } from './WalletHeroIcons';

export interface WalletPayoutsButtonProps {
  companyId: string;
  accessToken: string;
  influencerId?: string;
  kycApproved: boolean | null;
  onKycApprovalChange: (approved: boolean) => void;
  onWithdrawalComplete: () => void;
  disabled?: boolean;
}

/**
 * Verify: Whop Elements KYC (Verifications + KycElement). Withdraw: Whop withdraw overlay.
 */
const WalletPayoutsButton: React.FC<WalletPayoutsButtonProps> = ({
  companyId,
  accessToken,
  influencerId,
  kycApproved,
  onKycApprovalChange,
  onWithdrawalComplete,
  disabled = false,
}) => {
  const { isSwitchedAccount } = useContext(InfluencerDataContext);
  const { openPayoutsPanel } = useWhopPayoutsModal();

  const label =
    kycApproved === null ? 'Loading…' : kycApproved ? 'Withdraw' : 'Verify yourself';

  const handleClick = useCallback(async () => {
    if (kycApproved === null || isSwitchedAccount) {
      return;
    }
    await openPayoutsPanel(
      {
        companyId,
        accessToken,
        influencerId,
        onKycApprovalChange,
        onWithdrawalComplete,
      },
      kycApproved ? 'withdraw' : 'kyc',
    );
  }, [
    accessToken,
    companyId,
    influencerId,
    kycApproved,
    onKycApprovalChange,
    onWithdrawalComplete,
    isSwitchedAccount,
    openPayoutsPanel,
  ]);

  return (
    <Button
      variant="lime"
      w="100%"
      h="48px"
      minH="48px"
      fontSize="15px"
      boxShadow="none"
      isDisabled={disabled || isSwitchedAccount || kycApproved === null}
      isLoading={kycApproved === null}
      loadingText="Loading…"
      onClick={handleClick}
      leftIcon={<WalletWithdrawArrowIcon color={walletColors.textPrimary} />}
    >
      {label}
    </Button>
  );
};

export default WalletPayoutsButton;
